<!--
 * @Author: your name
 * @Date: 2021-10-22 16:53:53
 * @LastEditTime: 2023-04-20 17:51:02
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\realTimeAlarm\components\fireDeviceInfo.vue
-->
<template>
  <div class="deviceInfo">
    <!-- {{ detail }} -->
    <template v-if="detail.subDeviceMark">
      <div>
        <span>主机系统类型：</span>
        <span>
          {{ detail.deviceType | dic("SENU087") }}
        </span>
      </div>
      <div>
        <span>主机唯一标识号：</span>
        <span>
          {{ detail.parentThirdDeviceId }}
        </span>
      </div>
      <div>
        <span>部件名称：</span>
        <span>
          {{ detail.deviceName }}
        </span>
      </div>
      <div>
        <span>部件类型：</span>
        <span>
          {{ detail.subDeviceMark | dic("SENU094") }}
        </span>
      </div>
      <div>
        <span>部件地址：</span>
        <span>
          {{ detail.mac }}
        </span>
      </div>
      <div>
        <span>部件说明：</span>
        <span>
          {{ detail.thirdDeviceDesc }}
        </span>
      </div>
    </template>
    <template v-else>
      <div>
        <span>设备类型：</span>
        <span>
          {{ detail.deviceType | dic("SENU087") }}
        </span>
      </div>
      <div>
        <span>设备编号：</span>
        <span>
          {{ detail.thirdDeviceId }}
        </span>
      </div>
      <div>
        <span>设备名称：</span>
        <span>
          {{ detail.deviceName }}
        </span>
      </div>
      <div>
        <span> 消防型号：</span>
        <span>
          {{ detail.deviceVersion | dic("SENU095") }}
        </span>
      </div>
      <div>
        <span> 设备厂商：</span>
        <span>
          {{ detail.factoryName }}
        </span>
      </div>
      <div>
        <span> 唯一标识号：</span>
        <span>
          {{ detail.thirdDeviceId }}
        </span>
      </div>
      <div>
        <span> 设备状态：</span>
        <span>
          {{ detail.status == 1 ? "在线" : "离线" }}
        </span>
      </div>
      <div>
        <span> 控制模式：</span>
        <span>
          {{ detail.controlMode == 0 ? "单机模式" : "多分机模式" }}
        </span>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    detail: {},
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.deviceInfo {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px;
  div {
    display: flex;
    width: 47%;
    text-align: left;
    font-size: 14px;
    margin: 10px 0px;
    span:first-child {
      display: inline-block;
      width: 125px;
      color: #c3d3f5;
    }
    span:nth-child(2) {
      display: inline-block;
      width: 200px;
    }
  }
}
</style>
